import { entity } from '@gh/core-data';
import { AccessibleOfficeDto } from './accessible-office.dto';

export const AccessibleOfficeMapper = entity<AccessibleOfficeDto>();
